const A_FETCHING_USER = 'A_FETCHING_USER'
const A_FETCHING_USER_SUCCESS = 'A_FETCHING_USER_SUCCESS'
const A_FETCHING_USER_ERROR = 'A_FETCHING_USER_ERROR'
const A_FETCHING_USER_ASSESSMENT = 'A_FETCHING_USER_ASSESSMENT'

const A_ASSESSMENT_INITIALIZE = 'A_ASSESSMENT_INITIALIZE'
const A_ASSESSMENT_INITIALIZE_SUCCESS = 'A_ASSESSMENT_INITIALIZE_SUCCESS'
const A_ASSESSMENT_INITIALIZE_ERROR = 'A_ASSESSMENT_INITIALIZE_ERROR'
const A_SET_IN_TEST = 'A_SET_IN_TEST'

const A_FETCHING_ACTIVE_ITEM = 'A_FETCHING_ACTIVE_ITEM'
const A_FETCHING_ACTIVE_ITEM_SUCCESS = 'A_FETCHING_ACTIVE_ITEM_SUCCESS'
const A_FETCHING_ACTIVE_ITEM_ERROR = 'A_FETCHING_ACTIVE_ITEM_ERROR'

const A_SET_SELECTED_ANSWER = 'A_SET_SELECTED_ANSWER'

const A_SET_USER_ASSESSMENT = 'A_SET_USER_ASSESSMENT'

const A_SUBMITTING_SUBTEST = 'A_SUBMITTING_SUBTEST'
const A_SUBMITTING_SUBTEST_SUCCESS = 'A_SUBMITTING_SUBTEST_SUCCESS'
const A_SUBMITTING_SUBTEST_ERROR = 'A_SUBMITTING_SUBTEST_ERROR'

const A_FETCHING_NODES = 'A_FETCHING_NODES'
const A_FETCHING_NODES_SUCCESS = 'A_FETCHING_NODES_SUCCESS'
const A_FETCHING_NODES_ERROR = 'A_FETCHING_NODES_ERROR'

const A_SET_SUBTEST_REPORT = 'A_SET_SUBTEST_REPORT'

const A_FETCHING_SUBTEST_REPORT = 'A_FETCHING_SUBTEST_REPORT'
const A_FETCHING_SUBTEST_REPORT_SUCCESS = 'A_FETCHING_SUBTEST_REPORT_SUCCESS'
const A_FETCHING_SUBTEST_REPORT_ERROR = 'A_FETCHING_SUBTEST_REPORT_ERROR'

const A_FETCHING_ALL_ITEMS = 'A_FETCHING_ALL_ITEMS'
const A_FETCHING_ALL_ITEMS_SUCCESS = 'A_FETCHING_ALL_ITEMS_SUCCESS'
const A_FETCHING_ALL_ITEMS_ERROR = 'A_FETCHING_ALL_ITEMS_ERROR'

const A_FETCHING_ALL_PASSAGES = 'A_FETCHING_ALL_PASSAGES'
const A_FETCHING_ALL_PASSAGES_SUCCESS = 'A_FETCHING_ALL_PASSAGES_SUCCESS'
const A_FETCHING_ALL_PASSAGES_ERROR = 'A_FETCHING_ALL_PASSAGES_ERROR'

const A_FETCHING_COMPAREGROUP_UAS_SUCCESS = 'A_FETCHING_COMPAREGROUP_UAS_SUCCESS'

const A_FETCHING_GROUP_UAS = 'A_FETCHING_GROUP_UAS'
const A_FETCHING_GROUP_UAS_SUCCESS = 'A_FETCHING_GROUP_UAS_SUCCESS'
const A_FETCHING_GROUP_UAS_ERROR = 'A_FETCHING_GROUP_UAS_ERROR'

const A_UNLOAD_ASSESSMENT_PAGE = 'A_UNLOAD_ASSESSMENT_PAGE'
const A_LOAD_ASSESSMENT_PAGE = 'A_LOAD_ASSESSMENT_PAGE'

const A_FONT_MAGNIFY = 'A_FONT_MAGNIFY'
const A_FONT_DEMAGNIFY = 'A_FONT_DEMAGNIFY'

const A_LOAD_ASSESSMENT_TIMEREMAINING = 'A_LOAD_ASSESSMENT_TIMEREMAINING'


const A_SELECT_GROUP_UA = 'A_SELECT_GROUP_UA'

const A_SET_GUA_FILTER = 'A_SET_GUA_FILTER'

const CLEAR_USER_ASSESMENT = 'CLEAR_USER_ASSESMENT'

const A_IS_REFRESHING = 'A_IS_REFRESHING'
const A_REFRESHING_SUCCESS = 'A_REFRESHING_SUCCESS'
const A_REFRESHING_ERROR = 'A_REFRESHING_ERROR'

const SET_CURRENT_ASSISMENT_ID = 'SET_CURRENT_ASSISMENT_ID'
const SET_COMPARE_ASSISMENT_ID = 'SET_COMPARE_ASSISMENT_ID'

const SET_COMPARE_MODE = 'SET_COMPARE_MODE'

const UNSET_COMPARE_MODE = 'UNSET_COMPARE_MODE'
const SET_SWAP_STATUS = 'SET_SWAP_STATUS'

const SET_CURRENT_ASSISMENT_NAME = 'SET_CURRENT_ASSISMENT_NAME'
const SET_COMPARE_ASSISMENT_NAME = 'SET_COMPARE_ASSISMENT_NAME'
const SET_COMPARE_ASSISMENT_DATA = 'SET_COMPARE_ASSISMENT_DATA'
const SET_COMPARE_GUA_YEAR = 'SET_COMPARE_GUA_YEAR'


export function setSwapStatus(status)
{
  return {
  type: SET_SWAP_STATUS,
  status
  }
}

export function setCompareGUAYear(guaYear)
{
  return {
  type: SET_COMPARE_GUA_YEAR,
  guaYear
  }
}

export function setCumpareAssismentData(compareAssismentData){
  return {
    type: SET_COMPARE_ASSISMENT_DATA,
    compareAssismentData
  }
}

export function setCurrentAssismentId(currentAssismentId){
  return {
    type: SET_CURRENT_ASSISMENT_ID,
    value: currentAssismentId
  }
}

export function setCurrentAssismentName(currentAssismentName){
  console.log(currentAssismentName)
  return {
    type: SET_CURRENT_ASSISMENT_NAME,
    value: currentAssismentName
  }
}
export function setCompareAssismentName(compareAssismentName){
  return {
    type: SET_COMPARE_ASSISMENT_NAME,
    value: compareAssismentName
  }
}

export function setCompareMode(){
  return {
    type: SET_COMPARE_MODE,
    
  }
}
export function unsetCompareMode(){
  return {
    type: UNSET_COMPARE_MODE,
    
  }
}

export function setCompareAssismentId(compareAssismentId){
  return {
    type: SET_COMPARE_ASSISMENT_ID,
    compareAssismentId
  }
}

export function isRefreshing() {
  return {
    type: A_IS_REFRESHING,
  }
}

export function refreshingSuccess() {
  return { 
    type: A_REFRESHING_SUCCESS,
  }
}

export function refreshingError(error) {
  return {
    type: A_REFRESHING_ERROR,
    error,
  }
}

export function setGUAFilter(GUAFilter) {
  return {
    type: A_SET_GUA_FILTER,
    GUAFilter,
  }
}

export function selectGroupUA(selectedGroupUA) {
  return {
    type: A_SELECT_GROUP_UA,
    selectedGroupUA,
  }
}

export function fetchingGroupUAs() {
  return {
    type: A_FETCHING_GROUP_UAS,
  }
}
export function loadAssessmentHeader(){
  return {
    type: A_LOAD_ASSESSMENT_PAGE,
  }
}
export function unLoadAssessmentHeader(){
  return {
    type: A_UNLOAD_ASSESSMENT_PAGE,
  }
}

export function fetchingGroupUAsSuccess(groupUAs) {
  //localStorage.setItem('groupUAs',JSON.stringify(groupUAs)) 
  return {
    type: A_FETCHING_GROUP_UAS_SUCCESS,
    groupUAs,
  }
}

export function fetchingGroupUAsError(error) {
  return {
    type: A_FETCHING_GROUP_UAS_ERROR,
    error,
  }
}

export function fetchingAllPassages() {
  return {
    type: A_FETCHING_ALL_PASSAGES,
  }
}

export function fetchingAllPassagesSuccess(passages) {
  return {
    type: A_FETCHING_ALL_PASSAGES_SUCCESS,
    passages,
  }
}

export function fetchingAllPassagesError(error) {
  return {
    type: A_FETCHING_ALL_PASSAGES_ERROR,
    error,
  }
}

export function updateTimeRemaining(timeRemaining){
  return {
    type: A_LOAD_ASSESSMENT_TIMEREMAINING,
    timeRemaining
  }
}

export function onFontMagnify(){
  return {
    type : A_FONT_MAGNIFY,
  }
}

export function onFontdeMagnify(){
  return {
    type : A_FONT_DEMAGNIFY,
  }
}
 
export function fetchingAllItems() {
  return {
    type: A_FETCHING_ALL_ITEMS,
  }
}

export function fetchingAllItemsSuccess(items) {
  return {
    type: A_FETCHING_ALL_ITEMS_SUCCESS,
    items,
  }
}

export function fetchingAllItemsError(error) {
  return {
    type: A_FETCHING_ALL_ITEMS_ERROR,
    error,
  }
}

export function fetchingSubtestReport() {
  return {
    type: A_FETCHING_SUBTEST_REPORT,
  }
}

export function fetchingSubtestReportSuccess(report) {
  return {
    type: A_FETCHING_SUBTEST_REPORT_SUCCESS,
    report,
  }
}

export function fetchingSubtestReportError(error) {
  return {
    type: A_FETCHING_SUBTEST_REPORT_ERROR,
    error,
  }
}

export function setSubtestReport(report) {
  return {
    type: A_SET_SUBTEST_REPORT,
    report,
  }
}

export function fetchingNodes() {
  return {
    type: A_FETCHING_NODES,
  }
}

export function fetchingNodesSuccess(nodes) {
  localStorage.setItem('nodes',JSON.stringify(nodes)) 

  return {
    type: A_FETCHING_NODES_SUCCESS,
    nodes,
  }
}

export function fetchingNodesError(error) {
  return {
    type: A_FETCHING_NODES_ERROR,
    error,
  }
}

export function submittingSubtest() {
  return {
    type: A_SUBMITTING_SUBTEST,
  }
}

export function submittingSubtestSuccess() {
  return {
    type: A_SUBMITTING_SUBTEST_SUCCESS,
  }
}

export function submittingSubtestError(error) {
  return {
    type: A_SUBMITTING_SUBTEST_ERROR,
    error,
  }
}

export function setUserAssessment(userAssessment) {
  return {
    type: A_SET_USER_ASSESSMENT,
    userAssessment,
  }
}

export function setSelectedAnswer(answer) {
  return {
    type: A_SET_SELECTED_ANSWER,
    answer,
  }
}

export function fetchingActiveItem() {
  return {
    type: A_FETCHING_ACTIVE_ITEM,
  }
}

export function fetchingActiveItemSuccess(activeItem) {
  return {
    type: A_FETCHING_ACTIVE_ITEM_SUCCESS,
    activeItem,
  }
}

export function fetchingActiveItemError(error) {
  return {
    type: A_FETCHING_ACTIVE_ITEM_ERROR,
    error,
  }
}

export function assessmentInitialize() {
  return {
    type: A_ASSESSMENT_INITIALIZE,
  }
}

export function assessmentInitializeSuccess(userAssessment) {
  localStorage.setItem('userAssessment',JSON.stringify(userAssessment)) 
  return {
    type: A_ASSESSMENT_INITIALIZE_SUCCESS,
    userAssessment,
  }
}

export function assessmentInitializeError(error) {
  return {
    type: A_ASSESSMENT_INITIALIZE_ERROR,
    error,
  }
}

export function setInTest(inTestQ) {
  return {
    type: A_SET_IN_TEST,
    inTestQ,
  }
}

export function fetchingUser() {
  return {
    type: A_FETCHING_USER,
  }
}

export function fetchingUserSuccess(user) {
  return {
    type: A_FETCHING_USER_SUCCESS,
    user,
  }
}

export function fetchingUserError(error) {
  return {
    type: A_FETCHING_USER_ERROR,
    error,
  }
}

export function fetchingUserAssessment () {
  return {
    type: A_FETCHING_USER_ASSESSMENT,
  }
}

export default function clearUserAssesment(){
  return {
    type: CLEAR_USER_ASSESMENT,
  }
}

export function fetchingCompareGroupUAsSuccess(comparegroupUAs) {
  return {
   type: A_FETCHING_COMPAREGROUP_UAS_SUCCESS,
   comparegroupUAs,
 }
}
const TuserAssessment = JSON.parse(localStorage.getItem('userAssessment'))
//const TgroupUAs = JSON.parse(localStorage.getItem('groupUAs'))

const Tnodes = JSON.parse(localStorage.getItem('nodes'))


const initialState = {
  refreshingGUA: false,
  refreshingError: '',
  isFetchingUserAssessment: false,
  fetchingUserAssessmentError: '',
  userAssessment: (localStorage.getItem('userAssessment')) ? TuserAssessment:null,
  isFetchingUser: false,
  fetchingUserError: '',
  user: null,
  assessmentInitializingError: {},
  isInitializing: false,
  inTest: false,
  activeItem: null,
  isFetchingActiveItem: false,
  isFetchingActiveItemError: '',
  selectedAnswer: '',
  isSubmittingSubtest: false,
  isSubmittingSubtestError: '',
  isFetchingNodes: false,
  isFetchingNodesError: '',
  nodes: (localStorage.getItem('nodes')) ? Tnodes:null,
  subtestReport: null,
  isFetchingSubtestReport: false,
  isFetchingSubtestReportError: '',
  isFetchingAllItems: false,
  isFetchingAllItemsError: '',
  items: null,
  isFetchingAllPassages: false,
  isFetchingAllPassagesError: '',
  passages: null,
  isFetchingGroupUAs: false,
  groupUAs:  null,
  isFetchingGroupUAsError: '',
  selectedGroupUA: null,
  GUAFilter: null,
  loadAssessmentHeader: false,
  timeRemaining: 0,
  fontValue : 14,
  currentAssismentId:'',
  compareAssismentId : '',
  currentAssismentName:'',
  compareAssismentName : '',
  isCompare : false,
  isSwap : false,
  compareAssismentData : null,
  compareGuaYear: null

}

export function assessment (state = initialState, action) {
  switch (action.type) {
    case A_IS_REFRESHING :
      return {
        ...state,
        refreshingGUA: true,
      }
    case A_REFRESHING_SUCCESS :
      return {
        ...state,
        refreshingGUA: false,
      }
    case A_REFRESHING_ERROR :
      return {
        ...state,
        refreshingGUA: false,
        refreshingError: action.error,
      }
    case A_SET_GUA_FILTER :
      return {
        ...state,
        GUAFilter: action.GUAFilter,
      }
    case A_SELECT_GROUP_UA :
      return {
        ...state,
        selectedGroupUA: action.selectedGroupUA,
      }
    case A_LOAD_ASSESSMENT_PAGE : 
      return { ...state,
      loadAssessmentHeader: true
    }
    case A_UNLOAD_ASSESSMENT_PAGE : 
      return { ...state,
      loadAssessmentHeader: false
    }
    case A_FETCHING_GROUP_UAS :
      return {
        ...state,
        isFetchingGroupUAs: true,
      }
    case A_FETCHING_GROUP_UAS_SUCCESS :
      return {
        ...state,
        groupUAs: action.groupUAs,
        isFetchingGroupUAs: false,
        isInitializing: false,
      }
    case A_FETCHING_GROUP_UAS_ERROR :
      return {
        ...state,
        isFetchingGroupUAs: false,
        isFetchingGroupUAsError: action.error,
        isInitializing: false,
      }
    case A_FETCHING_ALL_PASSAGES :
      return {
        ...state,
        isFetchingAllPassages: true,
      }
    case A_FETCHING_ALL_PASSAGES_SUCCESS :
      return {
        ...state,
        isFetchingAllPassages: false,
        passages: action.passages,
      }
    case A_FETCHING_ALL_PASSAGES_ERROR :
      return {
        ...state,
        isFetchingAllPassages: false,
        isFetchingAllPassagesError: action.error,
      }

      case A_FETCHING_COMPAREGROUP_UAS_SUCCESS :
      return {
        ...state,
        comparegroupUAs: action.value,
        isFetchingGroupUAs: false,
        isInitializing: false,
      }
    case A_FETCHING_ALL_ITEMS :
      return {
        ...state,
        isFetchingAllItems: true,
      }
    case A_FETCHING_ALL_ITEMS_SUCCESS :
      return {
        ...state,
        isFetchingAllItems: false,
        items: action.items,
      }
    case A_FETCHING_ALL_ITEMS_ERROR :
      return {
        ...state,
        isFetchingAllItems: false,
        isFetchingAllItemsError: action.error,
      }
    case A_FETCHING_SUBTEST_REPORT : 
      return {
        ...state,
        isFetchingSubtestReport: true,
      }
    case A_LOAD_ASSESSMENT_TIMEREMAINING :
        return {
          ...state,
          timeRemaining: action.timeRemaining
        }  
    case A_FETCHING_SUBTEST_REPORT_SUCCESS :
      return {
        ...state,
        isFetchingSubtestReport: false,
        subtestReport: action.report,
      }
    case A_FETCHING_SUBTEST_REPORT_ERROR :
      return {
        ...state,
        isFetchingSubtestReport: false,
        isFetchingSubtestReportError: action.error,
      }
    case A_SET_SUBTEST_REPORT :
      return {
        ...state,
        subtestReport: action.report,
      }
    case A_FETCHING_NODES :
      return {
        ...state,
        isFetchingNodes: true,
      }
    case A_FETCHING_NODES_SUCCESS :
      return {
        ...state,
        nodes: action.nodes,
        isFetchingNodes: false,
      }
    case A_FETCHING_NODES_ERROR :
      return {
        ...state,
        isFetchingNodes: false,
        isFetchingNodesError: action.error,
      }
    case A_SUBMITTING_SUBTEST : 
      return {
        ...state,
        isSubmittingSubtest: true,
      }
    case A_SUBMITTING_SUBTEST_SUCCESS :
      return {
        ...state,
        isSubmittingSubtest: false,
        inTest: false,
      }
    case A_SUBMITTING_SUBTEST_ERROR :
      return {
        ...state,
        isSubmittingSubtest: false,
        isSubmittingSubtestError: action.error,
      }
    case A_SET_USER_ASSESSMENT :
      return {
        ...state,
        isInitializing: false,
        userAssessment: action.userAssessment,
      }
    case A_SET_SELECTED_ANSWER : 
      return {
        ...state,
        selectedAnswer: action.answer,
      }
    case A_FETCHING_ACTIVE_ITEM : 
      return {
        ...state,
        isFetchingActiveItem: true,
      }
    case A_FETCHING_ACTIVE_ITEM_SUCCESS :
      return {
        ...state,
        isFetchingActiveItem: false,
        activeItem: action.activeItem,
      }
    case A_FETCHING_ACTIVE_ITEM_ERROR :
      return {
        ...state,
        isFetchingActiveItem: false,
        isFetchingActiveItemError: action.error
      }     
    case A_FONT_MAGNIFY : 
        return {
          ...state,
          fontValue: state.fontValue + 1,
         }
    case A_FONT_DEMAGNIFY : 
        return {
          ...state,
          fontValue: state.fontValue - 1,
         }
    case A_ASSESSMENT_INITIALIZE :
      return {
        ...state,
        isInitializing: true,
      }
    case A_ASSESSMENT_INITIALIZE_SUCCESS :
      return {
        ...state,
        isInitializing: false,
        userAssessment: action.userAssessment,
        inTest: false,
      }
    case A_ASSESSMENT_INITIALIZE_ERROR :
      return {
        ...state,
        isInitializing: false,
        assessmentInitializingError: action.error,
        inTest: false,
      } 
    case A_SET_IN_TEST :
      return {
        ...state,
        inTest: action.inTestQ,
      }
    case A_FETCHING_USER :
      return {
        ...state,
        isFetchingUser: true,
      }
    case A_FETCHING_USER_SUCCESS :
      return {
        ...state,
        isFetchingUser: false,
        user: action.user,
      }
    case A_FETCHING_USER_ERROR :
      return {
        ...state,
        isFetchingUser: false,
        fetchingUserError: action.error,
      }   
    case A_FETCHING_USER_ASSESSMENT :
      return {
        ...state,
        isFetchingUserAssessment: true,
      }
    case CLEAR_USER_ASSESMENT : 
      return {
        ...state,
        userAssessment: null
      } 
    case  SET_CURRENT_ASSISMENT_NAME :
    return {
      ...state,
      currentAssismentName:action.value
    }
    case  SET_COMPARE_ASSISMENT_NAME :
    return {
      ...state,
      compareAssismentName:action.value
    }
  case  SET_CURRENT_ASSISMENT_ID :
    return {
      ...state,
      currentAssismentId:action.value
    }
    case  SET_COMPARE_ASSISMENT_ID :
    return {
      ...state,
      compareAssismentId:action.value
    }
    case SET_SWAP_STATUS :
    return {
      ...state,
      isSwap:action.value
    }
    case SET_COMPARE_MODE :
    return {
      ...state,
      isCompare:true
    }
    case SET_COMPARE_ASSISMENT_DATA :
    return {
      ...state,
      compareAssismentData:action.value
    }
    case UNSET_COMPARE_MODE :
    return {...state,
      isCompare:false

    }
    case SET_COMPARE_GUA_YEAR :
      return {
        ...state,
        compareGuaYear: action.value
      }
    default :
      return state
  }
}





// WEBPACK FOOTER //
// ./src/redux/modules/assessment.js